import "./singleBook.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect } from "react";
import Single from "../single/Single";
import { useParams } from "react-router-dom";

const SingleBook = () => {
  const { productId } = useParams();
  useEffect(() => {
    document.title = "Wishallbook";
  }, []);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Single type="main" bookID={productId} />
      </div>
    </div>
  );
};

export default SingleBook;
